export default __webpack_public_path__ + "static/media/ic-received-coin.f09b62b6.svg";